export default __webpack_public_path__ + "static/media/like_reverse.835b4765.svg";